/* eslint-disable node/no-unsupported-features */
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

export const FlagItIcon = (props) => (
    <SvgIcon viewBox="0 0 640 480" {...props}>
        <g fillRule="evenodd" strokeWidth="1pt">
            <path fill="#fff" d="M0 0h640v479.997H0z"/>
            <path fill="#009246" d="M0 0h213.331v479.997H0z"/>
            <path fill="#ce2b37" d="M426.663 0h213.331v479.997H426.663z"/>
        </g>
    </SvgIcon>
);

export default FlagItIcon;



// WEBPACK FOOTER //
// ./src/images/FlagItIcon.js